import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { urls  } from '../common/model/properties';
import { Subject } from 'rxjs';

@Injectable()
export class MfaService {
  private headerValue = '';
  props:any;
  result = new Subject();
  notify = new Subject<any>();
  private memberdetailsData =[];
  private memberdetailsPdfData = [];
  
  constructor(private http: HttpClient) {}

  generateOTP(sessionId: string, mfaType: string) {
    const headers = new HttpHeaders({
      'Accept': 'application/json'
    });

    const payload = {
      "sessionId": sessionId,
      "mfaType": mfaType
    }

    return this.http.post( urls.generateOTP, payload, { headers: headers } );
  } 

  verifyOTP(sessionId: string, otp: string, userName: string,  password: string) {
    const headers = new HttpHeaders({
      'Accept': 'application/json'
    });

    const payload = {
      "sessionId": sessionId,
      "otp": otp,
      "userName": userName,
      "password": password
    }

    return this.http.post( urls.verifyOTP, payload, { headers: headers } );
  } 
}
